/**
 * Hands the plan + addons chosen during the extended signup flow across the
 * account-creation → plan-activation → Stripe-checkout journey.
 *
 * sessionStorage (not navigation state) because the journey includes a full
 * redirect out to Stripe and back.
 */

const KEY = 'signup_plan_selection';

export interface SignupPlanSelection {
  planId: string;
  /** addon_apps.id values queued to add right after the subscription activates. */
  addonIds: string[];
  /** 'recommend' (AI picked it) or 'explore' (user picked it). */
  source: 'recommend' | 'explore';
}

export function saveSignupPlanSelection(selection: SignupPlanSelection): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(selection));
  } catch {
    /* non-fatal */
  }
}

export function getSignupPlanSelection(): SignupPlanSelection | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as SignupPlanSelection;
    if (!parsed?.planId) return null;
    return { planId: parsed.planId, addonIds: parsed.addonIds || [], source: parsed.source || 'explore' };
  } catch {
    return null;
  }
}

export function clearSignupPlanSelection(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* non-fatal */
  }
}
